import { TDR } from 'tdr-common';

function buildDefaultTimes(): string[] {
	const out: string[] = [];
	// 9:00 through 23:30 inclusive in 30-min increments
	for (let mins = 9 * 60; mins <= 23 * 60 + 30; mins += 30) {
		const h = Math.floor(mins / 60);
		const m = mins % 60;
		out.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
	}
	return out;
}

export const DEFAULT_PARAMETER_TIMES: string[] = buildDefaultTimes();

export function getParameterTimes(restaurant: TDR.Restaurant | undefined): string[] {
	const override = restaurant?.settings?.parameterTimes;
	return override && override.length > 0 ? override : DEFAULT_PARAMETER_TIMES;
}
